export default function update(
    {area}: UpdateAreaAction,
    setAreas: React.Dispatch<React.SetStateAction<{[areaLocalId: string]: Area}>>
) {
    setAreas((latestAreas) => ({
        ...latestAreas,
        [area.properties.localId]: area,
    }));
    return [area.properties.localId];
}
